<template>
<form>
  <div class="row">
    <table style='width:100%'>
      <tr>
        <td class="beepoint-svg text-center" @click="onBeePoint">
          <img src="../../assets/images/achieve/ic_beepoint.svg"/>
        </td>
        <td class="diamond-svg text-center" @click="onDiamond">
          <img src="../../assets/images/achieve/ic_diamond.svg"/>
        </td>
        <td class="honey-jars-svg text-center" @click="onHoney">
          <img src="../../assets/images/achieve/ic_honeyJars.svg"/>
        </td>
        <td class="rank-svg text-center" v-if="user.type_user === 1 || user.type_user === 3">
          <img src="../../assets/images/rank/Icon_level.svg"/>
        </td>
        <td class="rating-svg text-center" v-if="user.type_user === 2">
          <img src="../../assets/images/achieve/ic_voteGV.svg"/>
        </td>
      <tr/>
      <tr>
        <td class="amount-title" @click="onBeePoint">{{numberWithCommas(beepoint)}}</td>
        <td class="amount-title" @click="onDiamond">{{numberWithCommas(diamond)}}</td>
        <td class="amount-title" @click="onHoney">{{numberWithCommas(honeyJars)}}</td>
        <td class="amount-title" v-if="user.type_user === 1 || user.type_user === 3">{{user.rank.name}}</td>
        <td class="amount-title" v-if="user.type_user === 2">4.5</td>
      <tr/>
      <tr>
        <td class="text-center2">điểm BeePoint</td>
        <td class="text-center2">điểm Diamond</td>
        <td class="text-center2">Hũ mật ong</td>
        <td class="text-center2" v-if="user.type_user === 1 || user.type_user === 3">Hạng thành viên</td>
        <td class="text-center2" v-if="user.type_user === 2">Đánh giá</td>
      <tr/>
    </table>
  </div>
</form>
</template>
<script>
import itemRank from './itemRank'
import itemRating from './itemRating'
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
export default {
  components: {
    itemRank,
    itemRating
  },
  props: {
    user: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      beepoint: 0,
      diamond: 0,
      honeyJars: 0
    }
  },
  methods: {
    numberWithCommas(number) {
      return number != null ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0
    },
    onBeePoint() {
      this.$router.push('/beepoint')
    },
    onDiamond() {
      // console.log(this.user.rank_id)
      this.$router.push({name: 'diamond', params: {rank_id: this.user.rank_id}})
    },
    onHoney() {
      this.$router.push('honeyjars')
    }
  },
  apollo: {
    beepoint: {
      query: gql(graphql.COUNT_POINT_USER),
      variables() {
        return {
          uid: this.user.id,
          type: 1
        }
      },
      update: data => {
        if (data) return data.history_point_aggregate.aggregate && data.history_point_aggregate.aggregate.sum.amount
        else return 0
      },
      skip() {
        return this.user == null
      }
    },
    diamond: {
      query: gql(graphql.COUNT_POINT_USER),
      variables() {
        return {
          uid: this.user.id,
          type: 2
        }
      },
      update: data => {
        if (data) return data.history_point_aggregate.aggregate.sum.amount
        else return 0
      },
      skip() {
        return this.user == null
      }
    },
    honeyJars: {
      query: gql(graphql.COUNT_POINT_USER),
      variables() {
        return {
          uid: this.user.id,
          type: 3
        }
      },
      update: data => {
        if (data) return data.history_point_aggregate.aggregate.sum.amount
        else return 0
      },
      skip() {
        return this.user == null
      }
    }
  }
}
</script>
<style lang="scss">
.amount-title {
  text-align:center;
  font-weight: bold;
  color: #4B2D15;
  font-size: 17px;
  padding: 3px 0;
}
.text-center2 {
  text-align:center;
  color: #969FAD;
  white-space: nowrap;
  // font-family: Proxima Nova;
  font-size: 12px;
}
.font-color {
  color: #969FAD;
}
.beepoint-svg {
  cursor: pointer;
  img {
    width: 48px;
    height: 48px;
  }
}
.diamond-svg {
  cursor: pointer;
  img {
    width: 48px;
    height: 48px;
  }
}
.honey-jars-svg {
  cursor: pointer;
  img {
    width: 48px;
    height: 48px;
  }
}
.rating-svg {
  cursor: pointer;
  img {
    width: 48px;
    height: 48px;
  }
}
.rank-svg {
  img {
    width: 48px;
    height: 48px;
  }
}
@media (max-width: 414px) {
  
}
</style>



// WEBPACK FOOTER //
// Achieve.vue?bbd43a2c